/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Cli_HInputs */

const en_wc_tut_cli_h = /** @type {(inputs: Wc_Tut_Cli_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Power users: command line and AI agents`)
};

/**
* | output |
* | --- |
* | "9. Power users: command line and AI agents" |
*
* @param {Wc_Tut_Cli_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_cli_h = /** @type {((inputs?: Wc_Tut_Cli_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Cli_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_cli_h(inputs)
});
export { wc_tut_cli_h as "wc.tut.cli.h" }